export const breakpoint = 767.98;
export const onMobile = `@media (max-width: ${breakpoint}px)`;
